import React from 'react'

const Arrow = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={17}
    viewBox="0 0 19 17"
  >
    <g>
      <g>
        <path
          fill={fill || '#422364'}
          d="M18.092 7.688L10.057.336a1.34 1.34 0 0 0-1.775 0 1.08 1.08 0 0 0 0 1.625l5.892 5.39L.46 7c-.693 0-.693 3 0 3l13.714-.351-5.892 5.39a1.08 1.08 0 0 0 0 1.625c.245.224.567.336.888.336.321 0 .643-.112.888-.336l8.034-7.352a1.08 1.08 0 0 0 0-1.624z"
        />
      </g>
    </g>
  </svg>
)

export default Arrow
